import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/opr/")({
  beforeLoad: () => {
    throw redirect({ to: "/opr/selectionCalendar" });
  },
});
